var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    [
      _c(
        "div",
        {
          staticClass: "container mw-960",
          attrs: { slot: "layout-body" },
          slot: "layout-body"
        },
        [
          _c("div", { staticClass: "error-container text-center" }, [
            _c("img", {
              attrs: { src: "/static/images/signin-lcic-inactive.svg" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "typography--content-body",
              domProps: { innerHTML: _vm._s(_vm.$t("errors.unauthorized_msg")) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "link-back-to-ct" }, [
              _c("a", { attrs: { href: _vm.classtingUrl } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("errors.back_to_classting")) +
                    "\n        "
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("AppFooter", { attrs: { slot: "footer" }, slot: "footer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3029ac1b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3029ac1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/errors/views/Forbidden.vue
// module id = Ofg8
// module chunks = 1